import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFunctionUrl } from '../firebase';

const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

async function waitForAuthUser(auth) {
  if (auth.currentUser) {
    return auth.currentUser;
  }

  return new Promise((resolve) => {
    const timeoutId = window.setTimeout(() => {
      unsubscribe();
      resolve(auth.currentUser || null);
    }, 1500);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      window.clearTimeout(timeoutId);
      unsubscribe();
      resolve(user || null);
    });
  });
}

async function getAuthHeaders(requireAuth = true) {
  const headers = { ...DEFAULT_HEADERS };
  if (!requireAuth) {
    return headers;
  }

  const auth = getAuth();
  const user = auth.currentUser || await waitForAuthUser(auth);
  if (!user) {
    throw new Error('No hay una sesión activa.');
  }

  const token = await user.getIdToken();
  headers.Authorization = `Bearer ${token}`;
  return headers;
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body?.ok === false) {
    throw new Error(body?.error || `HTTP ${response.status}`);
  }

  return body?.data ?? body;
}

export async function apiRequest(functionName, options = {}) {
  const {
    method = 'POST',
    body,
    query,
    requireAuth = true,
  } = options;

  const headers = await getAuthHeaders(requireAuth);
  const url = new URL(getFunctionUrl(functionName));
  if (query && typeof query === 'object') {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null) url.searchParams.set(key, String(value));
    });
  }
  const response = await fetch(url.toString(), {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  return parseResponse(response);
}
